module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位名称："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.danwei))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属区域："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.areaValue))])])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "先进个人："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证书编号："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.bcode ? _vm.row.bcode : '无'))])])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "推广实施单位电子授权书："
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "bottom-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.danwei_pic,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.onPrint
    }
  }, [_vm._v("\n                点击下载证书\n              ")])], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "先进个人电子授权书："
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "bottom-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.person_pic,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.onPrintPerson
    }
  }, [_vm._v("\n                点击下载证书\n              ")])], 1)])], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2497612","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cdakejian/DakejianDetail.vue
// module id = 1595
// module chunks = 0